'use client';
import Lottie from 'lottie-react';
import LoaderAnimation from './assets/mainLoader.json';

import { SxProps, Theme } from '@mui/material';
import { BoxComponent, BoxComponentProps } from '../../base/box/Box';
//TODO: Change this 'require' import to regular import

export interface LoaderProps extends BoxComponentProps {
  container?: SxProps<Theme>;
}

export function Loader({ container, ...otherProps }: LoaderProps) {
  return (
    <BoxComponent
      sx={{
        height: '100vh',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...container,
      }}
    >
      <BoxComponent
        {...otherProps}
        sx={{
          '& svg > g >g:last-child': { display: 'none !important' },
          '& svg path': { fill: '#F9674E !important' },
          '& svg [stroke]': { stroke: '#F9674E !important' },
        }}
      >
        <Lottie animationData={LoaderAnimation} loop={true} />
      </BoxComponent>
    </BoxComponent>
  );
}
